import { FC, useMemo } from 'react';

import {
    RouteObject,
    RouterProvider,
    createBrowserRouter,
} from 'react-router-dom';

type Props = {
    routes: RouteObject[];
    basePath?: string | undefined;
};

/**
 * `LocaleRouterProvider` the router provider for the locale.
 *  Uses basename to handle routes with language prefix.
 */
const LocaleRouterProvider: FC<Props> = ({ routes, basePath }) => {
    const localeMatch = window.location.pathname.match(/^\/(en-(gb|us))/i);
    const localePath = localeMatch?.[0];

    const baseUrl = useMemo(() => {
        return [localePath, basePath].filter(Boolean).join('');
    }, [localePath, basePath]);

    const router = createBrowserRouter(routes, {
        basename: baseUrl ?? '',
    });

    return <RouterProvider router={router} />;
};

export default LocaleRouterProvider;
